import { render } from "./AssistedEnrollmentStep2.vue?vue&type=template&id=260c3fae&scoped=true"
import script from "./AssistedEnrollmentStep2.vue?vue&type=script&lang=js"
export * from "./AssistedEnrollmentStep2.vue?vue&type=script&lang=js"

import "./AssistedEnrollmentStep2.vue?vue&type=style&index=0&id=260c3fae&scoped=true&lang=css"

import exportComponent from "/home/runner/work/FONSNTE/FONSNTE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-260c3fae"]])

export default __exports__